<template>
  <el-dialog title="修改利率" :visible.sync="visible" width="400px">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="新利率">
        <el-input-number v-model="form.rate" :max="100" :precision="2" />
        <span style="margin-left: 10px;">%</span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateInterestRate } from '@/api/carft'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        rate: 0
      },
      dialogVisible: this.visible
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    handleSubmit() {
      updateInterestRate(this.user.id, this.form.rate).then(() => {
        this.$emit('refresh')
        this.closeDialog()
      })
    }
  }
}
</script>
